module.exports = __webpack_public_path__ + "img/assistant.b1fff80.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant.svg
// module id = ./assets/assistant.svg
// module chunks = 10